module.exports = __webpack_public_path__ + "img/mile4-m@2.b34c6236.jpg";